import { render, staticRenderFns } from "./c_input_item.vue?vue&type=template&id=52401300&scoped=true"
import script from "./c_input_item.vue?vue&type=script&lang=js"
export * from "./c_input_item.vue?vue&type=script&lang=js"
import style0 from "./c_input_item.vue?vue&type=style&index=0&id=52401300&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52401300",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52401300')) {
      api.createRecord('52401300', component.options)
    } else {
      api.reload('52401300', component.options)
    }
    module.hot.accept("./c_input_item.vue?vue&type=template&id=52401300&scoped=true", function () {
      api.rerender('52401300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_input_item.vue"
export default component.exports